// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentProviderSettingsController = function ($scope, $location, $routeParams, $http, $filter, PaymentProviderSettings,
    $rootScope, gettext, gettextCatalog, Features, PaymentExportService, StripeDisconnect, CountryList) {
    $scope.settingsLoaded = false;
    $scope.payoneOnAccountFeature = 'PayoneOnAccount';
    $scope.features = Features.features;
    $scope.countries = [];

    loadCountries();

    function loadCountries() {
        CountryList.getCountries().then(function (response) {
                $scope.countries = response.data.slice();
            },
            function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
    }

    function getPspSettingsPage(provider) {
        var basePath = '';
        switch (provider) {
            case "PayOne":
                basePath = 'partials/payment-providers-settings/settings-payone-edit.html' + $rootScope.linkVersion;
                break;
            case "FakeProvider":
                basePath = 'partials/payment-providers-settings/settings-fakeprovider-edit.html' + $rootScope.linkVersion;
                break;
            case "InvoicePayment":
                basePath = 'partials/payment-providers-settings/settings-invoicePayment-edit.html' + $rootScope.linkVersion;
                break;
            case "PayPal":
                basePath = 'partials/payment-providers-settings/settings-paypal-edit.html' + $rootScope.linkVersion;
                break;
            case "Stripe":
                basePath = 'partials/payment-providers-settings/settings-stripe-edit.html' + $rootScope.linkVersion;
                break;
            case "StripeV2":
                basePath = 'partials/payment-providers-settings/settings-stripev2-edit.html' + $rootScope.linkVersion;
                break;                
            case "Unzer":
                basePath = 'partials/payment-providers-settings/settings-unzer-edit.html' + $rootScope.linkVersion;
                break;
            case "UnzerV2":
                basePath = 'partials/payment-providers-settings/settings-unzerv2-edit.html' + $rootScope.linkVersion;
                break;                
            case "GoCardless":
                basePath = 'partials/payment-providers-settings/settings-gocardless-edit.html' + $rootScope.linkVersion;
                break;
            case "Adyen":
                basePath = 'partials/payment-providers-settings/settings-adyen-edit.html' + $rootScope.linkVersion;
                break;
            case "Worldline":
                basePath = 'partials/payment-providers-settings/settings-worldline-edit.html' + $rootScope.linkVersion;
                break;
            case "WorldlineV2":
                basePath = 'partials/payment-providers-settings/settings-worldlinev2-edit.html' + $rootScope.linkVersion;
                break;
            case "ThirdPartyIntegration":
                basePath = 'partials/payment-providers-settings/settings-external-edit.html' + $rootScope.linkVersion;
                break;
            case "PayEx":
                basePath = 'partials/payment-providers-settings/settings-payex-edit.html' + $rootScope.linkVersion;
                break;
            case "SepaXml":
                basePath = 'partials/payment-providers-settings/settings-sepaxml-edit.html' + $rootScope.linkVersion;
                break;
            case "PayExInvoiceService":
                basePath = 'partials/payment-providers-settings/settings-payexinvoiceservice-edit.html' + $rootScope.linkVersion;
                break;
            case "FarPay":
                basePath = 'partials/payment-providers-settings/settings-farpay-edit.html' + $rootScope.linkVersion;
                break;
            case "Mollie":
                basePath = 'partials/payment-providers-settings/settings-mollie-edit.html' + $rootScope.linkVersion;
                break;
            case "AmazonPay":
                basePath = 'partials/payment-providers-settings/settings-amazonpay-edit.html' + $rootScope.linkVersion;
                break;
            case "Reepay":
                basePath = 'partials/payment-providers-settings/settings-reepay-edit.html' + $rootScope.linkVersion;
                break;
            case "Riverty":
                basePath = 'partials/payment-providers-settings/settings-riverty-edit.html' + $rootScope.linkVersion;
                break;
            case "SwanOnAccount":
                basePath = 'partials/payment-providers-settings/settings-swanonaccount-edit.html' + $rootScope.linkVersion;
                break;
            default:
                break;
        }
        return basePath + $rootScope.linkVersion;
    }

    const CARD_TYPE = Object.freeze({
        'Visa': 'Visa',
        'Mastercard': 'Mastercard',
        'Amex': 'Amex',
        'UnionPay': 'UnionPay',
        'JCB': 'JCB',
        'Discover': 'Discover',
        'Diners': 'Diners',
        'Bancaire': 'Bancaire',
        'Dankort': 'Dankort',
    });

    const PROVIDER_NAMES = Object.freeze({
        'ThirdPartyIntegration': 'ThirdPartyIntegration',
        'Unzer': 'Unzer',
        'PayOne': 'PayOne',
        'GoCardless': 'GoCardless',
        'AmazonPay': 'AmazonPay',
        'Riverty': 'Riverty',
    });
    $scope.providerNames = PROVIDER_NAMES;

    const MollieStatusPhrases = Object.freeze({
        'PaymentsAvailable': 'You can receive payments',
        'PaymentsNotAvailable': 'You cannot receive payments yet',
        'SettlementsAvailable': 'You can receive settlements',
        'SettlementsNotAvailable': 'You cannot receive settlements yet',
    });

    const MollieProfileStatuses = Object.freeze({
        'verified': 'verified',
        'unverified': 'unverified',
        'blocked': 'blocked',
    });

    const THREE_D_SECURE_CARD_TYPE = Object.freeze({
        'VisaThreeDSecure': 'VisaThreeDSecure',
        'MasterCardThreeDSecure': 'MasterCardThreeDSecure',
        'AmericaExpressSafeKeyThreeDSecure': 'AmericaExpressSafeKeyThreeDSecure',
        'CBPaymentSecure': 'CBPaymentSecure'
    });

    var setCheckboxStatus = function (status, cardType) {
        switch (cardType) {
            case CARD_TYPE.Visa:
                $scope.visaCard = status;
                break;
            case CARD_TYPE.Mastercard:
                $scope.mastercardCard = status;
                break;
            case CARD_TYPE.Amex:
                $scope.amexCard = status;
                break;
            case CARD_TYPE.UnionPay:
                $scope.unionPayCard = status;
                break;
            case CARD_TYPE.JCB:
                $scope.jcbCard = status;
                break;
            case CARD_TYPE.Discover:
                $scope.discoverCard = status;
                break;
            case CARD_TYPE.Diners:
                $scope.dinersCard = status;
                break;
            case CARD_TYPE.Bancaire:
                $scope.bancaireCard = status;
                break;
            case CARD_TYPE.Dankort:
                $scope.dankortCard = status;
                break;
        }
    }

    const setThreeDSecureCheckboxStatus = function (status, secureCreditCardType) {
        switch (secureCreditCardType) {
            case THREE_D_SECURE_CARD_TYPE.VisaThreeDSecure:
                $scope.visaThreeDSecure = status;
                break;
            case THREE_D_SECURE_CARD_TYPE.MasterCardThreeDSecure :
                $scope.masterCardThreeDSecure = status;
                break;
            case THREE_D_SECURE_CARD_TYPE.AmericaExpressSafeKeyThreeDSecure:
                $scope.americaExpressSafeKeyThreeDSecure = status;
                break;
            case THREE_D_SECURE_CARD_TYPE.CBPaymentSecure:
                $scope.CBPaymentSecure = status;
                break;
        }
    }

    $scope.isSaveDisabled = false;
    $scope.isExternalSettingsEdit = false;
    if ($routeParams.paymentProvider === PROVIDER_NAMES.ThirdPartyIntegration && $routeParams.paymentProviderExternalId) {
        $scope.isExternalSettingsEdit = true;
    }

    const reloadPaymentProviderSettings = function () {
        PaymentProviderSettings.get({
            paymentProvider: $routeParams.paymentProvider,
            paymentProviderExternalId: $routeParams.paymentProviderExternalId
        }).$promise.then(function (response) {
            $scope.settings = response;

            if ($routeParams.paymentProvider === "SepaXml") {
                $scope.AdditionalLogicWhenSepaXmlSettingsLoaded();
            }

            if ($routeParams.paymentProvider === 'ThirdPartyIntegration' && !response.IntegrationInfo) {
                $scope.isSaveDisabled = true;
            }

            if ($routeParams.paymentProvider === 'SwanOnAccount') {
                $scope.initialSepaBeneficiary = response.SepaBeneficiary;
            }

            if ($scope.settings.PaymentProvider === 'Mollie') {
                $scope.AdditionalLogicWhenMollieSettingsLoaded();
            }

            if ($scope.settings.PaymentProvider === 'Stripe') {
                $scope.AdditionalLogicWhenStripeSettingsLoaded();
            }

            for (let i = 0; i < $scope.settings.AvailableCreditCardTypes.length; i++) {
                setCheckboxStatus(true, $scope.settings.AvailableCreditCardTypes[i]);
            }
            for (let i = 0; i < $scope.settings.ThreeDSecureCreditCardTypes.length; i++) {
                setThreeDSecureCheckboxStatus(true, $scope.settings.ThreeDSecureCreditCardTypes[i]);
            }
            $scope.settingsLoaded = true;
        });        
    }
    
    if ($routeParams.paymentProvider) {
        reloadPaymentProviderSettings();
        $scope.provider = $routeParams.paymentProvider;
        $scope.paymentProviderExternalId = $routeParams.paymentProviderExternalId;
        $scope.settingsPage = getPspSettingsPage($routeParams.paymentProvider);
    } else {
        $scope.providers = PaymentProviderSettings.query();
    }

    $scope.save = function () {
        $scope.settings.AvailableCreditCardTypes = [];
        $scope.settings.ThreeDSecureCreditCardTypes = [];

        if ($scope.visaCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Visa);
        }
        if ($scope.mastercardCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Mastercard);
        }
        if ($scope.amexCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Amex);
        }
        if ($scope.unionPayCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.UnionPay);
        }
        if ($scope.jcbCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.JCB);
        }
        if ($scope.discoverCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Discover);
        }
        if ($scope.dinersCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Diners);
        }
        if ($scope.bancaireCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Bancaire);
        }
        if ($scope.dankortCard) {
            $scope.settings.AvailableCreditCardTypes.push(CARD_TYPE.Dankort);
        }

        if ($scope.visaThreeDSecure) {
            $scope.settings.ThreeDSecureCreditCardTypes.push(THREE_D_SECURE_CARD_TYPE.VisaThreeDSecure);
        }
        if ($scope.masterCardThreeDSecure) {
            $scope.settings.ThreeDSecureCreditCardTypes.push(THREE_D_SECURE_CARD_TYPE.MasterCardThreeDSecure);
        }
        if ($scope.americaExpressSafeKeyThreeDSecure) {
            $scope.settings.ThreeDSecureCreditCardTypes.push(THREE_D_SECURE_CARD_TYPE.AmericaExpressSafeKeyThreeDSecure);
        }
        if ($scope.CBPaymentSecure) {
            $scope.settings.ThreeDSecureCreditCardTypes.push(THREE_D_SECURE_CARD_TYPE.CBPaymentSecure);
        }

        if($scope.settings.PaymentProvider === 'SwanOnAccount'){
            $scope.updateSwanOnAccount();
        }
        else {
            $scope.settings.$update({ paymentProvider: $routeParams.paymentProvider }, function () {
                $location.path("/settings/payment-providers-list");
            });
        }
    };

    $scope.updateSwanOnAccount = function () {
        var updateSwan = function (successCallback) {
            $scope.settings.$update({paymentProvider: $routeParams.paymentProvider}, function (response) {
                if (response.RedirectUrl) {
                    window.location = response.RedirectUrl;
                }
                if(successCallback)
                    successCallback();
            });
        };

        if (!$scope.settings.SepaBeneficiary && $scope.initialSepaBeneficiary) {
            $scope.yesCancel(
                gettextCatalog.getString(gettext('Cancel Standing order')),
                gettextCatalog.getString(gettext('The configured IBAN for payouts is empty. Would you like to cancel payouts?')),
                function () {
                    updateSwan(function () {
                        window.location.reload()
                    });
                },
                function () {
                    $scope.settings.SepaBeneficiary = $scope.initialSepaBeneficiary
                });
        } else {
            updateSwan();
        }
    }

    $scope.isPayOneOnAccountFeatureAvailable = function () {
        return $rootScope.features[$scope.payoneOnAccountFeature];
    }

    $scope.cardChange = function (isChecked, element) {
        setCheckboxStatus(isChecked, element);
    }

    $scope.threeDSecureCreditCardChange = function (isChecked, secureCreditCardType) {
        setThreeDSecureCheckboxStatus(isChecked, secureCreditCardType);
    }

    $scope.saveList = function () {
        for (var i = 0; i < $scope.providers.length; i++) {
            (function () { // required to avoid late binding of 'item'
                var item = $scope.providers[i];
                if (typeof item.Status !== 'undefined' && item.IsConfigurable !== false) {
                    var targetUrl = baseUrl + "api/v1/paymentProviderSettings/" + item.PaymentProvider + "/status";
                    if (item.PaymentProviderExternalId) {
                        targetUrl = baseUrl + "api/v1/paymentProviderSettings/" + item.PaymentProvider + "/status" + "/" + item.PaymentProviderExternalId;
                    }
                    $http({
                        method: "POST",
                        url: targetUrl,
                        cache: false,
                        data: item.Status,
                        headers: {"Content-Type": "application/json"}
                    }).then(
                        function (response) {
                            // CAREFUL: This is JS, which uses LATE BINDING!!! 'item' doesn't refer to the value it was assigned before!!
                            item.Status = response.data;
                            item.saved = true;
                        },
                        function (data) {
                            item.saved = false;
                        });
                }
            })();
        }
    };

    var refreshStates = function (settings, refreshFn) {
        for (var i = 0; i < $scope.providers.length; i++) {
            (function () { // required to avoid late binding of 'item'
                var item = $scope.providers[i];
                if (typeof item.Status != 'undefined') {
                    if (item.PaymentProvider !== settings.PaymentProvider || item.PaymentProviderExternalId !== settings.PaymentProviderExternalId)
                        refreshFn(item.Status);
                }
            })();
        }
    };

    $scope.refreshCCStates = function (settings) {
        refreshStates(settings, function (status) {
            status.CreditCardActive = false;
        });
    };

    $scope.refreshDebitStates = function (settings) {
        refreshStates(settings, function (status) {
            status.DebitActive = false;
        });
    };

    $scope.refreshOnAccountStates = function (settings) {
        if (settings.PaymentProvider === "SwanOnAccount")
            $scope.providers.find(x => x.PaymentProvider === "InvoicePayment").Status.BlackLabelActive = false;
        if (settings.PaymentProvider === "InvoicePayment") {
            let swanSettings = $scope.providers.find(x => x.PaymentProvider === "SwanOnAccount");
            if (swanSettings) swanSettings.Status.BlackLabelActive = false;
        }
    };

    $scope.refreshBetalingsserviceStates = function (settings) {
        refreshStates(settings, function (status) {
            status.BetalingsserviceActive = false;
        });
    };

    $scope.refreshAutogiroStates = function (settings) {
        refreshStates(settings, function (status) {
            status.AutogiroActive = false;
        });
    };

    $scope.refreshAvtalegiroStates = function (settings) {
        refreshStates(settings, function (status) {
            status.AvtalegiroActive = false;
        });
    };

    $scope.refreshiDEALStates = function (settings) {
        refreshStates(settings, function (status) {
            status.iDEALActive = false;
        });
    };

    $scope.refreshApplePayStates = function (settings) {
        refreshStates(settings, function (status) {
            status.ApplePayActive = false;
        });
    };

    $scope.refreshAfterPayStates = function (settings) {
        refreshStates(settings, function (status) {
            status.AfterPayActive = false;
        });
    };

    function sortNumber(a, b) {
        return a - b;
    }

    $scope.addMaxDebitAmount = function (newMaxDebitAmount) {
        var value = parseInt(newMaxDebitAmount);
        if ((isNaN(value)) || (value < 1))
            return;
        if (typeof $scope.settings.MaxDebitAmounts == 'undefined' ||
            $scope.settings.MaxDebitAmounts.length == 0) {
            $scope.settings.MaxDebitAmounts = [];
            $scope.settings.MaxDebitAmountDefault = value;
        } else {
            for (var i = 0; i < $scope.settings.MaxDebitAmounts.length; i++) {
                if ($scope.settings.MaxDebitAmounts[i] == value)
                    return;
            }
        }
        $scope.settings.MaxDebitAmounts.push(value);
        $scope.settings.MaxDebitAmounts.sort(sortNumber);
    };
    
    $scope.whiteLabelProviders = function (provider) {
        if (provider.PaymentProvider === "ThirdPartyIntegration") {
            return false;
        }
        
        // IT-11380: Reepay to be placed as separate category in "payment settings"
        if (provider.PaymentProvider === "Reepay") {
            return false;
        }
        
        return provider.IsDebitProvider ||
            provider.IsCreditCardProvider ||
            provider.IsOnAccountProvider ||
            provider.IsBetalingsserviceProvider ||
            provider.IsAutogiroProvider ||
            provider.IsAvtalegiroProvider ||
            provider.IsAfterPayProvider;
    };

    $scope.externalType = function (provider) {
        return provider.PaymentProviderExternalId != null;
    };


    $scope.changeBatchBookingState = function () {

        $scope.settings.BatchBooking = !$scope.settings.BatchBooking;
    };

    $scope.useCustomTransactionAmountLimitChange = function () {

        if (!$scope.settings.UseCustomTransactionAmountLimit) {
            $scope.settings.MaximumTransactionNumberPerFile = null;
        }
    };

    $scope.useCustomDDPrenotificationPolicyChanged = function () {
        if (!$scope.settings.UseCustomDDPrenotificationPolicy) {
            $scope.settings.InitialDDPrenotificationDays = 5;
            $scope.settings.RecurringDDPrenotificationDays = 2;
        }
    };

    $scope.fetch = function () {
        $http({
            method: "POST", url: "api/v1/paymentProviderSettings/externalIntegration/fetch",
            params: {},
            data: $scope.settings,
            headers: {"Content-Type": "application/json"},
            cache: false
        }).then(function (result) {
            $scope.settings.IntegrationInfo = result.data;
            $scope.isSaveDisabled = false;
        });
    };

    //ThirdPartyPspSettings specific code. Using to set dynamic MerchantPspSettings in next format
    // settings: {
    // ...,
    // MerchantPspSettings: [
    // {KeyName: "ApiKey"},
    // {KeyValue: "ApiKeyValue"},
    // ...
    // ],
    // }
    $scope.MerchantSettingsArray = [];

    $scope.setMerchantSettingValue = function (MerchantSettingKeyName) {

        if ($scope.settings.MerchantSettings === undefined || $scope.settings.MerchantSettings === null ||
            $scope.settings.MerchantSettings.length === 0) {
            $scope.settings.MerchantSettings = $scope.MerchantSettingsArray;
        }
        let currentValue = $scope.settings.MerchantSettings.find(function (entity) {
            return entity.KeyName === MerchantSettingKeyName;
        });
        let newValue = $scope.MerchantSettingsArray.find(function (entity) {
            return entity.KeyName === MerchantSettingKeyName;
        });

        currentValue.KeyValue = newValue.KeyValue;

    };

    gettext(MollieStatusPhrases.PaymentsAvailable);
    gettext(MollieStatusPhrases.PaymentsNotAvailable);
    gettext(MollieStatusPhrases.SettlementsAvailable);
    gettext(MollieStatusPhrases.SettlementsNotAvailable);

    gettext(MollieProfileStatuses.verified);
    gettext(MollieProfileStatuses.unverified);
    gettext(MollieProfileStatuses.blocked);
    //Do not remove line bellow, this is an indicator for translation tool to grab that text
    gettext("Reepay");
    gettext("WorldlineV2");

    $scope.disconnectFromMollie = function() {
        function disconnect() {
            $scope.settings.ConnectionIdentifier = null;
            $scope.save();
        }

        if ($scope.settings.ConnectionWasRevokedExternally) disconnect();
        else {
            $scope.yesCancel(
                gettextCatalog.getString(gettext('Disconnect from Mollie')),
                gettextCatalog.getString(gettext('If you want to disconnect your Mollie account from Frisbii, please make sure to also delete the billwerk-app from your Mollie account')),
                function () { disconnect(); },
                function () { }
            );
        }
    }

    $scope.redirectToSwanOnboarding = function (){
        if ($scope.settings.OnboardingUrl)
            window.location = $scope.settings.OnboardingUrl;
        else
            $scope.settings.$update({ paymentProvider: $routeParams.paymentProvider }, function (response) {
                window.location = response.RedirectUrl;
            });
    }

    $scope.redirectToSwanConsent = function (){
        if ($scope.settings.StandingOrderConsentUrl)
            window.location = $scope.settings.StandingOrderConsentUrl;
    }

    $scope.swanDataInvalid = function () {
        return this.form.iban.$invalid;
    }

    $scope.getSepaDirectDebitFormats = function() {
        return PaymentExportService.getDebitFormats();
    }

    $scope.getSepaCreditFormats = function() {
        return PaymentExportService.getCreditFormats();
    }

    function findOption(event) {
        var selectedOption = Array.from(event.currentTarget.childNodes).filter(x => x.selected === true)[0];
        if(selectedOption) {
            return selectedOption.value;
        }
    }
    
    $scope.onDebitPaymentExportFormatChange = function(event) {
        $scope.settings.DebitTransferPaymentExportFormat = findOption(event);
    }
    
    $scope.onCreditPaymentExportFormatChange = function(event) {
        $scope.settings.CreditTransferPaymentExportFormat = findOption(event);
    }

    if ($location.absUrl().includes("settings/payment-providers-list")) {
        const analyticData = {
            url: $location.absUrl(),
            path: "settings/payment-providers-list",
            userAgent: window.navigator.userAgent,
        };
    }

    $scope.refreshVippsMobilePayStates = function (settings) {
        refreshStates(settings, function (status) {
            status.VippsMobileActive = false;
        });
    };

    $scope.refreshPayPalStates = function (settings) {
        refreshStates(settings, function (status) {
            status.PayPalActive = false;
        });
    };

    $scope.refreshTWINTStates = function (settings) {
        refreshStates(settings, function (status) {
            status.TWINTActive = false;
        });
    };

    $scope.AdditionalLogicWhenSepaXmlSettingsLoaded = function(){
        if(!$scope.settings.DebitTransferPaymentExportFormat) {
            $scope.DebitTransferPaymentExportFormat = PaymentExportService.getDebitFormats().slice(-1)[0];
            $scope.settings.DebitTransferPaymentExportFormat = $scope.DebitTransferPaymentExportFormat.id;
        }
        else {
            var debitElementIndex = PaymentExportService.getDebitFormats().findIndex(x => x.id === $scope.settings.DebitTransferPaymentExportFormat);
            $scope.DebitTransferPaymentExportFormat = PaymentExportService.getDebitFormats()[debitElementIndex];
        }

        if(!$scope.settings.CreditTransferPaymentExportFormat) {
            $scope.CreditTransferPaymentExportFormat = PaymentExportService.getCreditFormats().slice(-1)[0];
            $scope.settings.CreditTransferPaymentExportFormat = $scope.CreditTransferPaymentExportFormat.id;
        }
        else {
            var creditElementIndex = PaymentExportService.getCreditFormats().findIndex(x => x.id === $scope.settings.CreditTransferPaymentExportFormat);
            $scope.CreditTransferPaymentExportFormat = PaymentExportService.getCreditFormats()[creditElementIndex];
        }        
    }
    
    $scope.AdditionalLogicWhenMollieSettingsLoaded = function () {
        if ($routeParams.error)
            $scope.notify("error", $routeParams.error);

        $scope.molliePaymentsPhrase = $scope.settings.CanReceivePayments ?
            MollieStatusPhrases.PaymentsAvailable : MollieStatusPhrases.PaymentsNotAvailable;
        $scope.mollieSettlementsPhrase = $scope.settings.CanReceiveSettlements ?
            MollieStatusPhrases.SettlementsAvailable : MollieStatusPhrases.SettlementsNotAvailable;

        $scope.settings._hasInvalidProfile = !$scope.settings.AvailableProfiles.some(function (x) { return x.Id === $scope.settings.ProfileId; });
        if ($scope.settings._hasInvalidProfile)
            $scope.settings.AvailableProfiles.push({ Name: $scope.settings.ProfileId, Id: $scope.settings.ProfileId });

        let currentProfileId = $scope.settings.ProfileId;
        $scope.filterProfiles = function() {
            $scope.settings._profilesToDisplay = $scope.settings.Mode === "Live"
                ? $scope.settings.AvailableProfiles.filter(profile => profile.Status === "verified")
                : $scope.settings.AvailableProfiles;

            // preselect current profile after switching between modes
            let profileIds = $scope.settings._profilesToDisplay.map(function(item) { return item.Id; });
            if (profileIds.includes(currentProfileId))
                $scope.settings.ProfileId = currentProfileId;

            $scope.settings._profilesToDisplay.forEach(function (profile) {
                profile.Name = profile.Name + " (" + gettextCatalog.getString(gettext(MollieProfileStatuses[profile.Status])) + ")";
            });
        };

        $scope.filterProfiles();        
    }

    $scope.AdditionalLogicWhenStripeSettingsLoaded = function () {        
        $scope.isStripeConnectButtonClicked = false;
        $scope.isStripeDisconnectButtonClicked = false;
        if ($routeParams.error)
            $scope.notify("error", $routeParams.error);
    }

    $scope.disconnectFromStripe = function() {
        $scope.yesCancel(
            gettextCatalog.getString(gettext('Disconnect from Stripe')),
            gettextCatalog.getString(gettext('Are you sure you want to disconnect your Stripe account from Frisbii?')),
            function () {
                $scope.isStripeDisconnectButtonClicked = true;
                StripeDisconnect.disconnect().then(function(response){                    
                    reloadPaymentProviderSettings();
                });
            },
            function () { }
        );
    }

    $scope.connectToStripe = function() {
        $scope.isStripeConnectButtonClicked = true;
    }

    $scope.addCountryToWhiteList = function (newCountry) {
        if (!newCountry) {
            return;
        }

        let isCountryAlreadyAdded = $scope.settings.CountryWhiteList?.some(function (country) {
            return country === newCountry;
        }) || false;

        if (isCountryAlreadyAdded) {
            return;
        }

        $scope.settings.CountryWhiteList = $scope.settings.CountryWhiteList || [];
        $scope.settings.CountryWhiteList.push(newCountry);
    }

    $scope.removeCountryFromWhiteList = function (countryToRemove) {
        $scope.settings.CountryWhiteList = ($scope.settings.CountryWhiteList || []).filter(function(country) {
            return country !== countryToRemove;
        });
    }

    $scope.getCountryName = function (code) {
        if ($scope.countries && code) {
            let country = $scope.countries.find(function (country) {
                return country.TwoLetterCode === code
            });
            return ($scope.locale in country) ? country[$scope.locale] : country["EN"];
        }
    }
};

PaymentProviderSettingsController.$inject = ['$scope', '$location', '$routeParams', '$http', '$filter', 'PaymentProviderSettings',
    '$rootScope', 'gettext', 'gettextCatalog', 'Features', "PaymentExportService", "StripeDisconnect", "CountryList"];
